<tt-page *ngIf="!!page">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-datetime ttLabel="reg_datetime" [ttModel]="page.reg_datetime" ttReadonly></tt-datetime>
        <tt-input ttLabel="reg_by_portal_user_name" [ttModel]="page.reg_by_portal_user_name" ttReadonly></tt-input>
        <tt-textarea ttLabel="note" [ttModel]="page.note" ttReadonly></tt-textarea>
    </tt-card>
</tt-page>
